import { hierarchyItems } from './constants'

export const createAverages = (drivers) => {
  const { dates, depots, supervisors, markets } = grabUniques(drivers)
  const depotAverages = depots
    .flatMap((depot) => dates.map((date) => generateAverages(depot, drivers, date, 'depot_id')))
    .filter((depot) => !!depot)
  const supervisorAverages = supervisors.flatMap((supervisor) =>
    dates.map((date) => generateAverages(supervisor, drivers, date, 'supervisor_id'))
  )
  const marketAverages = markets.flatMap((market) =>
    dates.map((date) => generateAverages(market, drivers, date, 'market_id'))
  )
  const systemAverages = dates.map((date) => generateAverages('system', drivers, date, 'system'))

  return {
    [hierarchyItems.DEPOTS]: depotAverages,
    [hierarchyItems.SUPERVISORS]: supervisorAverages,
    [hierarchyItems.MARKETS]: marketAverages,
    [hierarchyItems.SYSTEM]: systemAverages,
  }
}

export const grabUniques = (drivers) => {
  // a unique list of dates
  return {
    dates: [...new Set(drivers.map((driver) => driver.period_date))],
    depots: [...new Set(drivers.map((driver) => driver.depot_id))],
    supervisors: [...new Set(drivers.map((driver) => driver.supervisor_id))],
    markets: [...new Set(drivers.map((driver) => driver.market_id))],
  }
}

const generateAverages = (id, drivers, date, matchProperty, isDepot) => {
  const datedItem = { id, name: id, date }

  const driverMatches = drivers.filter((driver) =>
    id === 'system'
      ? driver.period_date === date
      : driver[matchProperty] === datedItem.id && driver.period_date === date
  )
  if (driverMatches.length === 0) {
    return null
  }
  if (matchProperty === 'depot_id') {
    datedItem.supervisor_name = driverMatches[0].supervisor_name
    datedItem.market = driverMatches[0].market
    datedItem.depot_name = driverMatches[0].depot_name
  }
  if (matchProperty === 'supervisor_id') {
    datedItem.market = Array.from(new Set(driverMatches.map((driver) => driver.market)))
    // datedItem.market = driverMatches[0].market
    datedItem.depot_name = Array.from(new Set(driverMatches.map((driver) => driver.depot_name)))
    datedItem.supervisor_name = driverMatches[0].supervisor_name
  }

  datedItem.current_score = 0.93
  getMetricAverages('productivity', dataStub.productivity, datedItem, driverMatches)
  getMetricAverages('accuracy', dataStub.accuracy, datedItem, driverMatches)

  return datedItem
}

const getMetricAverages = (metricType, metricGrouping, averageStub, drivers) => {
  // create metric grouping here
  averageStub[metricType] = {}

  // loop through each key of the stub and get the average from the drivers.
  Object.keys(metricGrouping).forEach((key) => {
    const validAttributes =
      key === 'loaded_volume'
        ? drivers.map((driver) => driver[key]).filter((value) => !!value)
        : drivers.map((driver) => driver[metricType][key]).filter((value) => !!value)

    const total = validAttributes.length > 0 ? validAttributes.reduce((a, b) => a + b) : 0
    averageStub[metricType][key] = total / drivers.length
  })
}
const dataStub = {
  productivity: {
    orders: 0,
    stops: 0,
    total_miles: 0,
    loaded_miles: 0,
    utilization: 0,
    driving_time: 0,
    loading_time: 0,
    dropping_time: 0,
    loaded_volume: 0,
    miles_est_act_diff: 0,
  },
  accuracy: {
    mispulls: 0,
    loaded_vs_standard_gal: 0,
  },
}

// const dataStub = {
//   productivity: {
//     orders: 0,
//     stops: 0,
//     total_miles: 0,
//     loaded_miles: 0,
//     utilization: 0,
//     sick_days: 0,
//     miles_est_act_diff: 0,
//     driving_time: 0,
//     driving_time_diff: 0,
//     loading_time: 0,
//     loading_est_act_diff: 0,
//     dropping_time: 0,
//     dropping_est_act_diff: 0,
//   },
//   accuracy: {
//     mispulls: 0,
//     // misdrops: 0,
//     // data_input_accuracy: 0,
//     // loaded_vs_standard_gal: 0,
//   },
//   safety: {
//     speeding_incidents: 0,
//     harsh_braking: 0,
//     unsafe_distances: 0,
//     texting: 0,
//   },
// }
